module.exports = __webpack_public_path__ + "static/media/CAlogo.9637a199.png";